export const fetchGeoMapResources = async (vueInstance) => {
    let self = vueInstance;

    TELSA.loading(true);
    self.alarmsList = self.$store.state.alarmsList; // set the initial alarm list.

    // Fetch all the resources for the GeoMap
    let result = (await self.$http.get(`${TELSA.apiHost}geomap/sites`)).body;
    self.geoSiteList = result.sites;
    self.remoteSectorsLinkLines = result.remote_sector_link_lines;
    // Site Tags
    self.siteTags = result.site_groups;
    for(let siteTag of self.siteTags) {
        siteTag.sitesCount = result.sites.filter(s => s.site_groups.includes(siteTag.site_group_id)).length;
    }
    // Site Technicians(Users)
    self.siteTechnicians = JSON.parse(JSON.stringify(self.$store.state.batchConfig.users));
    for(let siteTechnician of self.siteTechnicians) {
        siteTechnician.sitesCount = result.sites.filter(s => s.user_id == siteTechnician.user_id).length;
    }
    // Network Categories
    self.networkCategories = result.network_categories;
    for(let network of self.networkCategories) {
        network.sitesCount = result.sites.filter(s => s.network_category_id == network.network_category_id).length;
    }
    // Build resource lists for alarm grids
    self.alarmGridResources = {
        technicianOptions: self.$store.state.batchConfig.users.map(u => u.user_username),
        localeOptions: result.site_locales,
        siteTagOptions: result.site_groups.map(s => s.site_group_name),
        issueTemplates: result.issue_templates_list
    };
    // Build Advanced filters value lists
    self.advancedFiltersValueLists.site_locale = [];
    for(let site_locale of result.site_locales) {
        self.advancedFiltersValueLists.site_locale.push({text: site_locale.site_locale, value: site_locale.site_locale});
    }
    self.advancedFiltersValueLists.site_locale.push({text: '(Blanks)', value: 'blanks'});
    self.advancedFiltersValueLists.alarm_severity = [{text: 'Critical', value: 'CRITICAL'},{text: 'Major', value: 'MAJOR'},{text: 'Minor', value: 'MINOR'},{text: 'Observational', value: 'OBSERVATIONAL'}];

    
    self.alarmViews = (await self.$http.get(`${TELSA.apiHost}views/list/alarm`)).body;

    TELSA.loading(false);
    // console.log('self.geoSiteList: ', self.geoSiteList);
    // console.log('self.remoteSectorsLinkLines: ', self.remoteSectorsLinkLines);
    // console.log('self.siteTags: ', self.siteTags);
    // console.log('self.siteTechnicians: ', self.siteTechnicians);
    // console.log('self.networkCategories: ', self.networkCategories);
    // console.log('self.alarmGridResources: ', self.alarmGridResources);
    // console.log('self.alarmViews: ', self.alarmViews);
    // console.log('self.advancedFiltersValueLists: ', self.advancedFiltersValueLists);
    return;
    
};


export const getMarkerIcon = (vueInstance, marker) => {
    let self = vueInstance;

    let geoColors = self.$store.state.batchConfig.webapp_settings.alarms.alarmColors.geographical;
    geoColors.default = {background: '#ffffff', foreground: '#000000'};
    let useAlarmSectors = true; // set this to False if we dont want to show alarm sectors
    let icon = (marker.icon && self.generalSettings.networkCategoryIcons) ? marker.icon : useAlarmSectors ? 'mdi-readioactive-alarm-sector' : 'mdi-radioactive';
    let strokeColor = '#000000';
    let rotateDeg = 0;
    let size = 24;
    let markerElement = document.createElement('div');
    markerElement.id = `marker_${marker.siteId}`;

    // This is for WMSATSEA (Miramar) to view the heading of their vessels
    if(marker.internal_data && marker.internal_data.vessel_status && marker.internal_data.vessel_status.heading) {
        rotateDeg = isNaN(Number(marker.internal_data.vessel_status.heading)) ? 0 : Number(marker.internal_data.vessel_status.heading);
    }
    // Remote sectors
    if(marker.remoteSectorId) {
        markerElement.id = `remoteSector_${marker.remoteSectorId}`;
        icon = 'mdi-readioactive-remote-sector';
    }

    // Turn selected map marker to blue.
    // if(self.currentMidx == idx) {
    //     fillColor = 'blue';
    // }
    if(marker.alarms.length) {
        marker.severity = 'normal';
        // Find the most severe alarm for this marker which map filters allow for.
        if(marker.criticalCount && self.siteAlarmFilters.critical) {
            marker.severity = 'critical';
        }
        else if(marker.majorCount && self.siteAlarmFilters.major) {
            marker.severity = 'major';
        }
        else if(marker.minorCount && self.siteAlarmFilters.minor) {
            marker.severity = 'minor';
        }
        else if(marker.observationalCount && self.siteAlarmFilters.observational) {
            marker.severity = 'observational';
        }
        else if(marker.defaultCount && self.siteAlarmFilters.default) {
            marker.severity = 'default';
        }

        if(icon == 'mdi-readioactive-alarm-sector') {
            // figure out the most severe alarm sector for each draw sector
            for(let drawSector of marker.draw_sectors) {
                if(drawSector.critical_count && self.siteAlarmFilters.critical) {
                    drawSector.color = geoColors['critical'].background;
                }
                else if(drawSector.major_count && self.siteAlarmFilters.major) {
                    drawSector.color = geoColors['major'].background;
                }
                else if(drawSector.minor_count && self.siteAlarmFilters.minor) {
                    drawSector.color = geoColors['minor'].background;
                }
                else if(drawSector.observational_count && self.siteAlarmFilters.observational) {
                    drawSector.color = geoColors['observational'].background;
                }
                else if(drawSector.default_count && self.siteAlarmFilters.default) {
                    drawSector.color = geoColors['default'].background;
                }
                else {
                    drawSector.color = geoColors['normal'].background;
                }
            }
        }
        //TODO: dynamically set the size from the number and type of alarms. amount can be obtained from SETTINGS page.
        size = 34;
        markerElement.innerHTML = buildIconElement(icon, geoColors[marker.severity].background, strokeColor, marker.draw_sectors, rotateDeg, size);
        //markerElement.classList.add('blinking'); // TA DA!!!!!
    }
    else {
        markerElement.innerHTML = buildIconElement(icon, geoColors['normal'].background, strokeColor, marker.draw_sectors, rotateDeg, size);
        marker.severity = 'normal';
    }
    
    markerElement.style.position = 'relative';
    markerElement.style.top = `${(size / 2)}px`;
    return markerElement;
};



export const getPolylineOptions = (vueInstance, polyline) => {
    let self = vueInstance;

    let geoColors = self.$store.state.batchConfig.webapp_settings.alarms.alarmColors.geographical;
    let strokeColor = geoColors.normal.background;
    let strokeWeight = 2;
    if(polyline.alarms.length) {
        if(polyline.criticalCount && self.linkAlarmFilters.critical) {
            strokeColor = geoColors['critical'].background;
        }
        else if(polyline.majorCount && self.linkAlarmFilters.major) {
            strokeColor = geoColors['major'].background;
        }
        else if(polyline.minorCount && self.linkAlarmFilters.minor) {
            strokeColor = geoColors['minor'].background;
        }
        else if(polyline.observationalCount && self.linkAlarmFilters.observational) {
            strokeColor = geoColors['observational'].background;
        }
        else if(polyline.defaultCount && self.linkAlarmFilters.default) {
            //strokeColor = geoColors['default'].background;
            strokeColor = '#ffffff';
        }
        strokeWeight = 4;
    }

    let polylineDirectionSymbol = {
        path: 2,
        strokeColor: strokeColor,
        strokeWeight: strokeWeight
    }
    let icons = self.generalSettings.showLinkDirectionality ? [
        {icon: polylineDirectionSymbol, offset: `${self.polylineSymbolPositions.one}%`}, 
        {icon: polylineDirectionSymbol, offset: `${self.polylineSymbolPositions.two}%`}, 
        {icon: polylineDirectionSymbol, offset: `${self.polylineSymbolPositions.three}%`},
        {icon: polylineDirectionSymbol, offset: `${self.polylineSymbolPositions.four}%`}
    ] : null;
    

    return {
        map: self.googleMapsObj,
        path: polyline.path,
        clickable: true,
        draggable: false,
        editable: false,
        visible: mapItemVisible(self, polyline),
        strokeColor: strokeColor,
        strokeWeight: strokeWeight,
        strokeOpacity: 1,
        zIndex: mapItemZIndex(self, polyline),
        icons: icons
    };            
};


export const animatePolylineSymbols = (vueInstance, timestamp) => {
    let self = vueInstance;

    // Only update the positions if enough time has passed for the next frame
    if (timestamp - self.animationLastTimestamp >= 16) {  // ~60 FPS
        self.polylineSymbolPositions.one = ((self.polylineSymbolPositions.one + 1) % 100);
        self.polylineSymbolPositions.two = ((self.polylineSymbolPositions.two + 1) % 100);
        self.polylineSymbolPositions.three = ((self.polylineSymbolPositions.three + 1) % 100);
        self.polylineSymbolPositions.four = ((self.polylineSymbolPositions.four + 1) % 100);

        Object.values(self.polylinesDict).forEach(polyline => {
            let polylineElement = self.mapElementsDict[polyline.siteId];
            //polylineElement.setOptions({icons: null});
            if(self.generalSettings.showLinkDirectionality) {
                let polylineElementIcons = polylineElement.get('icons');
                let icons = [
                    {icon: polylineElementIcons[0].icon, offset: `${self.polylineSymbolPositions.one}%`},
                    {icon: polylineElementIcons[1].icon, offset: `${self.polylineSymbolPositions.two}%`},
                    {icon: polylineElementIcons[2].icon, offset: `${self.polylineSymbolPositions.three}%`},
                    {icon: polylineElementIcons[3].icon, offset: `${self.polylineSymbolPositions.four}%`},
                ]
                polylineElement.setOptions({icons: icons});
            }
        });
        self.animationLastTimestamp = timestamp;
    }
    self.animationFrameId = requestAnimationFrame(self.animatePolylineSymbols);
};



export const mapItemVisible = (vueInstance, mapItem) => {
    let self = vueInstance;

    let filters = (mapItem.isLink ? self.linkAlarmFilters : self.siteAlarmFilters)
    // Site Tags. If there are no site tag filters selected, then we show everything.
    let mapItemTags = mapItem.siteGroups;
    let siteTagFound = (self.siteTagFilters.length ? (mapItemTags.length && mapItemTags.some(tag => { return self.siteTagFilters.includes(tag); })) : true);
    if(!siteTagFound) {
        return false;
    }
    // Site Technicians
    let siteTechnicianFound = (self.siteTechnicianFilters.length ? self.siteTechnicianFilters.includes(mapItem.userId) : true);
    if(!siteTechnicianFound) {
        return false;
    }
    // Network Categories
    let networkCategoryFound = (self.siteNetworkCategoryFilters.length ? self.siteNetworkCategoryFilters.includes(mapItem.networkCategoryId) : true);
    if(!networkCategoryFound) {
        return false;
    }
    // Service Affecting
    if(filters.serviceAffecting && !mapItem.alarms.some(a => a.alarm_service_affecting == 't')) {
        return false;
    }
    // Alarm Severity
    if(mapItem.alarms.length) {
        let visible = (
            (filters.critical && !!mapItem.criticalCount) ||
            (filters.major && !!mapItem.majorCount) ||
            (filters.minor && !!mapItem.minorCount) ||
            (filters.observational && !!mapItem.observationalCount) ||
            (filters.default && !!mapItem.defaultCount)
        );
        return visible;
    }
    return filters.normal;
};



export const mapItemZIndex = (vueInstance, mapItem) => {
    let self = vueInstance;
    if(mapItem.remoteSectorId) {
        mapItem = self.markersDict[mapItem.siteId]; // in case youre wondering, this does NOT change the original "mapItem" passed into this function. Because thats how js works.
    }
    let z = mapItem.idx;
    if(mapItem.alarms.length) {
        if(mapItem.criticalCount) {
            z = 10005;
        }
        else if(mapItem.majorCount) {
            z = 10004;
        }
        else if(mapItem.minorCount) {
            z = 10003;
        }
        else if(mapItem.observationalCount) {
            z = 10002;
        }
        else if(mapItem.defaultCount) {
            z = 10001;
        }
    }
    return z;
};



export const createPolylineElement = (vueInstance, polyline) => {
    let self = vueInstance;

    let polylineElement = new google.maps.Polyline(getPolylineOptions(self, polyline));
    const clickListener = polylineElement.addListener('click', (e) => self.mapItemClicked(e, polyline));
    const rightClickListener = polylineElement.addListener('contextmenu', (e) => self.mapItemRightClick(e, polyline));
    self.listenersDict[polyline.siteId] = {
        element: polylineElement, 
        handlers: { clickListener, rightClickListener } 
    };
    return polylineElement;
};


export const createAdvancedMarkerElement = (vueInstance, marker, mapElementId) => {
    let self = vueInstance;

    let markerElement = new self.AdvancedMarkerElement({
        map: self.googleMapsObj,
        position: marker.position,
        content: getMarkerIcon(self, marker),
        gmpClickable: true,
        gmpDraggable: false,
        zIndex: mapItemZIndex(self, marker)
    });

    removeListeners(self, [mapElementId]);
    // Store listeners separately for addListener (gmp-click) and addEventListener (mouse events)
    const clickListener = markerElement.addListener('gmp-click', (e) => self.mapItemClicked(e, marker));
    const mouseEnterHandler = (e) => self.mapItemMouseOver(e, marker);
    const mouseLeaveHandler = (e) => self.mapItemMouseOut(e, marker);
    const rightClickHandler = (e) => self.mapItemRightClick(e, marker);
    markerElement.addEventListener('mouseenter', mouseEnterHandler);
    markerElement.addEventListener('mouseleave', mouseLeaveHandler);
    markerElement.addEventListener('contextmenu', rightClickHandler);
    self.listenersDict[mapElementId] = {
        element: markerElement, 
        handlers: { clickListener, mouseEnterHandler, mouseLeaveHandler, rightClickHandler } 
    };

    return markerElement;
};



export const removeListeners = (vueInstance, ids = []) => {
    let self = vueInstance;

    if(ids.length === 0) {
        // This means do it for all of them
        Object.values(self.listenersDict).forEach(listener => {
            google.maps.event.removeListener(listener.handlers.clickListener);
            google.maps.event.removeListener(listener.handlers.rightClickListener);
            if(listener.element.removeEventListener) {
                listener.element.removeEventListener('mouseenter', listener.handlers.mouseEnterHandler);
                listener.element.removeEventListener('mouseleave', listener.handlers.mouseLeaveHandler);
                listener.element.removeEventListener('contextmenu', listener.handlers.rightClickHandler);
            }
        });
        self.listenersDict = {}; // Reset listeners after removal
    }
    else {
        // Remove listeners for specific ids
        ids.forEach(id => {
            const listener = self.listenersDict[id];
            if (listener) {
                google.maps.event.removeListener(listener.handlers.clickListener);
                google.maps.event.removeListener(listener.handlers.rightClickListener);
                if(listener.element.removeEventListener) {
                    listener.element.removeEventListener('mouseenter', listener.handlers.mouseEnterHandler);
                    listener.element.removeEventListener('mouseleave', listener.handlers.mouseLeaveHandler);
                    listener.element.removeEventListener('contextmenu', listener.handlers.rightClickHandler);
                }
                // Remove the listener entry from the dictionary
                delete self.listenersDict[id];
            }
        });
    }
};







export const buildIconElement = (iconName, iconColor, strokeColor, sectors=null, rotateDeg=0, size=24) => {
    iconColor = iconColor || '#626262';
    let svgSrc = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="${size}px" height="${size}px" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M12 10a2 2 0 0 1 2 2a2 2 0 0 1-.47 1.29L16.7 22h-2.13L12 14.93L9.43 22H7.3l3.17-8.71A2 2 0 0 1 10 12a2 2 0 0 1 2-2m0-2a4 4 0 0 0-4 4c0 .5.1 1 .28 1.46l-.88 2.4A6.026 6.026 0 0 1 6 12a6 6 0 0 1 6-6a6 6 0 0 1 6 6c0 1.47-.53 2.81-1.4 3.86l-.88-2.4C15.9 13 16 12.5 16 12a4 4 0 0 0-4-4m0-4a8 8 0 0 0-8 8c0 2.36 1 4.5 2.64 5.94l-.72 2A10.005 10.005 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10c0 3.23-1.54 6.11-3.92 7.94l-.72-2C19 16.5 20 14.36 20 12a8 8 0 0 0-8-8z" fill="${iconColor}" stroke="${strokeColor}"/></svg>`;
    
    if(iconName == 'mdi-switch') {
        svgSrc = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="${size}px" height="${size}px" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M13 18h1a1 1 0 0 1 1 1h7v2h-7a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1H2v-2h7a1 1 0 0 1 1-1h1v-2H8a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-3v2m0-12h1V4h-1v2M9 4v2h2V4H9m0 4v2h2V8H9m0 4v2h2v-2H9z" fill="${iconColor}" stroke="${strokeColor}"/></svg>`;
    }
    else if(iconName == 'mdi-router-network') {
        svgSrc = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="${size}px" height="${size}px" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M5 9c-1.1 0-2 .9-2 2v4a2 2 0 0 0 2 2h6v2h-1c-.55 0-1 .45-1 1H2v2h7c0 .55.45 1 1 1h4c.55 0 1-.45 1-1h7v-2h-7c0-.55-.45-1-1-1h-1v-2h6c1.11 0 2-.89 2-2v-4a2 2 0 0 0-2-2H5m1 3h2v2H6v-2m3.5 0h2v2h-2v-2m3.5 0h2v2h-2v-2z" fill="${iconColor}" stroke="${strokeColor}"/></svg>`;
    }
    else if(iconName == 'mdi-access-point-network') {
        svgSrc = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="${size}px" height="${size}px" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M4.93 3.93A9.969 9.969 0 0 0 2 11c0 2.76 1.12 5.26 2.93 7.07l1.41-1.41A7.938 7.938 0 0 1 4 11c0-2.21.89-4.22 2.34-5.66L4.93 3.93m14.14 0l-1.41 1.41A7.955 7.955 0 0 1 20 11c0 2.22-.89 4.22-2.34 5.66l1.41 1.41A9.969 9.969 0 0 0 22 11c0-2.76-1.12-5.26-2.93-7.07M7.76 6.76A5.98 5.98 0 0 0 6 11c0 1.65.67 3.15 1.76 4.24l1.41-1.41A3.99 3.99 0 0 1 8 11c0-1.11.45-2.11 1.17-2.83L7.76 6.76m8.48 0l-1.41 1.41A3.99 3.99 0 0 1 16 11c0 1.11-.45 2.11-1.17 2.83l1.41 1.41A5.98 5.98 0 0 0 18 11c0-1.65-.67-3.15-1.76-4.24M12 9a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-1 6v4h-1a1 1 0 0 0-1 1H2v2h7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1h7v-2h-7a1 1 0 0 0-1-1h-1v-4h-2z" fill="${iconColor}" stroke="${strokeColor}"/></svg>`;
    }
    else if(iconName == 'mdi-console-network-outline') {
        svgSrc = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="${size}px" height="${size}px" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M15 20a1 1 0 0 0-1-1h-1v-2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4v2h-1a1 1 0 0 0-1 1H2v2h7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1h7v-2h-7m-8-5V5h10v10H7m1-8.11l3.56 3.56L8 14h2.53l2.92-2.92c.33-.34.33-.9 0-1.26L10.5 6.89H8m8 5.33h-2.67V14H16v-1.78z" fill="${iconColor}" stroke="${strokeColor}"/></svg>`;
    }
    else if(iconName == 'mdi-server-network') {
        svgSrc = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="${size}px" height="${size}px" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M13 19h1a1 1 0 0 1 1 1h7v2h-7a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1H2v-2h7a1 1 0 0 1 1-1h1v-2H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-7v2M4 3h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m5 4h1V5H9v2m0 8h1v-2H9v2M5 5v2h2V5H5m0 8v2h2v-2H5z" fill="${iconColor}" stroke="${strokeColor}"/></svg>`;
    }
    else if(iconName == 'mdi-network-outline') {
        svgSrc = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="${size}px" height="${size}px" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M15 20a1 1 0 0 0-1-1h-1v-2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4v2h-1a1 1 0 0 0-1 1H2v2h7a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1h7v-2h-7m-8-5V5h10v10H7z" fill="${iconColor}" stroke="${strokeColor}"/></svg>`;
    }
    else if(iconName == 'mdi-ip-network') {
        svgSrc = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="${size}px" height="${size}px" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M15 9h-2V7h2v2m7 11v2h-7a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1H2v-2h7a1 1 0 0 1 1-1h1v-2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4v2h1a1 1 0 0 1 1 1h7M9 5H7v10h2V5m2 10h2v-4h2a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4v10z" fill="${iconColor}" stroke="${strokeColor}"/></svg>`;
    }
    else if(iconName == 'mdi-router') {
        svgSrc = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="${size}px" height="${size}px" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10s10-4.5 10-10S17.5 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8s8 3.58 8 8s-3.58 8-8 8m1-7v3h2l-3 3l-3-3h2v-3m-6 0h3v2l3-3l-3-3v2H5m6 0V8H9l3-3l3 3h-2v3m6 0h-3V9l-3 3l3 3v-2h3" fill="${iconColor}" stroke="${strokeColor}"/></svg>`;
    }
    else if(iconName == 'mdi-router-wireless') {
        svgSrc = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="${size}px" height="${size}px" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M20.2 5.9l.8-.8C19.6 3.7 17.8 3 16 3c-1.8 0-3.6.7-5 2.1l.8.8C13 4.8 14.5 4.2 16 4.2s3 .6 4.2 1.7m-.9.8c-.9-.9-2.1-1.4-3.3-1.4c-1.2 0-2.4.5-3.3 1.4l.8.8c.7-.7 1.6-1 2.5-1c.9 0 1.8.3 2.5 1l.8-.8M19 13h-2V9h-2v4H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2M8 18H6v-2h2v2m3.5 0h-2v-2h2v2m3.5 0h-2v-2h2v2z" fill="${iconColor}" stroke="${strokeColor}"/></svg>`;
    }
    else if(iconName == 'mdi-tower-fire') {
        svgSrc = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="${size}px" height="${size}px" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M17 4v4h1v2h-.36L21 23h-2.07l-.56-2.17L12 17.15l-6.37 3.68L5.07 23H3l3.36-13H6V8h1V4H6V3l6-2l6 2v1h-1M7.28 14.43l-.95 3.69L10 16l-2.72-1.57M15.57 10H8.43l-.63 2.42l4.2 2.43l4.2-2.43l-.63-2.42m2.1 8.12l-.95-3.69L14 16l3.67 2.12z" fill="${iconColor}" stroke="${strokeColor}"/></svg>`;
    }
    else if(iconName == 'mdi-transmission-tower') {
        svgSrc = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="${size}px" height="${size}px" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M8.28 5.45l-1.78-.9L7.76 2h8.47l1.27 2.55l-1.78.89L15 4H9l-.72 1.45M18.62 8h-4.53l-.79-3h-2.6l-.79 3H5.38L4.1 10.55l1.79.89l.73-1.44h10.76l.72 1.45l1.79-.89L18.62 8m-.85 14H15.7l-.24-.9L12 15.9l-3.47 5.2l-.23.9H6.23l2.89-11h2.07l-.36 1.35L12 14.1l1.16-1.75l-.35-1.35h2.07l2.89 11m-6.37-7l-.9-1.35l-1.18 4.48L11.4 15m3.28 3.12l-1.18-4.48l-.9 1.36l2.08 3.12z" fill="${iconColor}" stroke="${strokeColor}"/></svg>`;
    }
    else if(iconName == 'mdi-satellite-uplink') {
        svgSrc = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="${size}px" height="${size}px" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M11.86 2l-.52 1.93c4.41.85 7.86 4.3 8.71 8.72l1.95-.52C20.95 7.03 16.96 3.04 11.86 2m-1.04 3.86l-.52 1.95c3.04.46 5.42 2.84 5.88 5.87l1.94-.52c-.66-3.72-3.57-6.66-7.3-7.3m-7.1 3.83A7.96 7.96 0 0 0 5 18.28V22h3v-1.59c.95.39 1.97.59 3 .59c1.14 0 2.27-.25 3.3-.72L3.72 9.69m6.07.07l-.53 1.96a3 3 0 0 1 3 3l1.97-.52c-.23-2.34-2.1-4.2-4.44-4.44z" fill="${iconColor}" stroke="${strokeColor}"/></svg>`;
    }
    else if(iconName == 'mdi-weather-cloudy') {
        svgSrc = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="${size}px" height="${size}px" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M6 19a5 5 0 0 1-5-5a5 5 0 0 1 5-5c1-2.35 3.3-4 6-4c3.43 0 6.24 2.66 6.5 6.03L19 11a4 4 0 0 1 4 4a4 4 0 0 1-4 4H6m13-6h-2v-1a5 5 0 0 0-5-5c-2.5 0-4.55 1.82-4.94 4.19C6.73 11.07 6.37 11 6 11a3 3 0 0 0-3 3a3 3 0 0 0 3 3h13a2 2 0 0 0 2-2a2 2 0 0 0-2-2z" fill="${iconColor}" stroke="${strokeColor}"/></svg>`;
    }
    else if(iconName == 'mdi-security-network') {
        svgSrc = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="${size}px" height="${size}px" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M13 19h1a1 1 0 0 1 1 1h7v2h-7a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1H2v-2h7a1 1 0 0 1 1-1h1v-1.66C8.07 16.13 6 13 6 9.67v-4L12 3l6 2.67v4c0 3.33-2.07 6.46-5 7.67V19M12 5L8 6.69V10h4V5m0 5v6c1.91-.47 4-2.94 4-5v-1h-4z" fill="${iconColor}" stroke="${strokeColor}"/></svg>`;
    }
    else if(iconName == 'mdi-navigation') {
        svgSrc = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="${size}px" height="${size}px" style="-ms-transform: rotate(${rotateDeg}deg); -webkit-transform: rotate(${rotateDeg}deg); transform: rotate(${rotateDeg}deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M12 2L4.5 20.29l.71.71L12 18l6.79 3l.71-.71L12 2Z" fill="${iconColor}" stroke="${strokeColor}"/></svg>`;
    }
    else if(iconName == 'mdi-hexagon-multiple') {
        svgSrc = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="${size}px" height="${size}px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M10.25 2c.19 0 .36.11.44.26l2.22 3.96l.09.28l-.09.28l-2.22 3.96c-.08.15-.25.26-.44.26h-4.5c-.19 0-.36-.11-.44-.26L3.09 6.78L3 6.5l.09-.28l2.22-3.96c.08-.15.25-.26.44-.26h4.5m0 11c.19 0 .36.11.44.26l2.22 3.96l.09.28l-.09.28l-2.22 3.96c-.08.15-.25.26-.44.26h-4.5c-.19 0-.36-.11-.44-.26l-2.22-3.96L3 17.5l.09-.28l2.22-3.96c.08-.15.25-.26.44-.26h4.5m9.25-5.5c.19 0 .36.11.44.26l2.22 3.96l.09.28l-.09.28l-2.22 3.96c-.08.15-.25.26-.44.26H15c-.19 0-.36-.11-.44-.26l-2.22-3.96l-.09-.28l.09-.28l2.22-3.96c.08-.15.25-.26.44-.26h4.5z" fill="${iconColor}" stroke="${strokeColor}"/></svg>`;
    }
    else if(iconName == 'mdi-account-circle') {
        svgSrc = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="${size}px" height="${size}px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M12 19.2c-2.5 0-4.71-1.28-6-3.2c.03-2 4-3.1 6-3.1s5.97 1.1 6 3.1a7.232 7.232 0 0 1-6 3.2M12 5a3 3 0 0 1 3 3a3 3 0 0 1-3 3a3 3 0 0 1-3-3a3 3 0 0 1 3-3m0-3A10 10 0 0 0 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10c0-5.53-4.5-10-10-10z" fill="${iconColor}" stroke="${strokeColor}"/></svg>`;
    }
    else if(iconName == 'mdi-alpha-s-circle') {
        svgSrc = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="${size}px" height="${size}px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M11 7a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2v2H9v2h4a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-2V9h4V7h-4m1-5a10 10 0 0 1 10 10a10 10 0 0 1-10 10A10 10 0 0 1 2 12A10 10 0 0 1 12 2z" fill="${iconColor}" stroke="${strokeColor}"/></svg>`;
    }

    else if(iconName == 'mdi-radioactive') {
        if(sectors && sectors.length) {
            let src = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="${size}px" height="${size}px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">`;
            src += `<g><path d="M12 10a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2" fill="${iconColor}" stroke="${strokeColor}"/></g>`; // dot in the middle of the icon
            for(let sector of sectors) {
                src += `<g transform="rotate(${sector.azimuth - 180} 12 12)"><path fill="${sector.enabled ? iconColor : '#808080'}" stroke="${strokeColor}" d="m12,10 m0,12c-1.95,0 -3.78,-0.56 -5.31,-1.53l3.31,-5a4.037,4.037 0 0 0 4,0l3.31,5a9.903,9.903 0 0 1 -5.31,1.53"/></g>`;
            }
            src += '</svg>';
            svgSrc = src;
        }
        else {
            svgSrc = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="${size}px" height="${size}px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M12 8a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4z" fill="${iconColor}" stroke="${strokeColor}"/></svg>`;
        }
    }

    else if(iconName == 'mdi-readioactive-remote-sector') {
        let src = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="${size}px" height="${size}px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">`;
        for(let sector of sectors) {
            src += `<g transform="rotate(${sector.azimuth - 180} 12 12)"><path fill="${sector.enabled ? iconColor : '#808080'}" stroke="${strokeColor}" d="m12,10 m0,12c-1.95,0 -3.78,-0.56 -5.31,-1.53l3.31,-5a4.037,4.037 0 0 0 4,0l3.31,5a9.903,9.903 0 0 1 -5.31,1.53"/></g>`;
        }
        src += '</svg>';
        svgSrc = src;
    }

    else if(iconName == 'mdi-readioactive-alarm-sector') {
        if(sectors && sectors.length) {
            let src = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="${size}px" height="${size}px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24">`;
            src += `<g><path d="M12 10a2 2 0 0 1 2 2a2 2 0 0 1-2 2a2 2 0 0 1-2-2a2 2 0 0 1 2-2" fill="${iconColor}" stroke="${strokeColor}"/></g>`;
            for(let sector of sectors) {
                src += `<g transform="rotate(${sector.azimuth - 180} 12 12)"><path fill="${sector.enabled ? (sector.color ? sector.color : iconColor)  : '#808080'}" stroke="${strokeColor}" d="m12,10 m0,12c-1.95,0 -3.78,-0.56 -5.31,-1.53l3.31,-5a4.037,4.037 0 0 0 4,0l3.31,5a9.903,9.903 0 0 1 -5.31,1.53"/></g>`;
            }
            src += '</svg>';
            svgSrc = src;
        }
        else {
            svgSrc = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="${size}px" height="${size}px" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path d="M12 8a4 4 0 0 0-4 4a4 4 0 0 0 4 4a4 4 0 0 0 4-4a4 4 0 0 0-4-4z" fill="${iconColor}" stroke="${strokeColor}"/></svg>`;
        }
    }

    return svgSrc;
};



